import ActionTypes from "../constants/action_types";

export default function clearPermissionGroups() {
  return {
    type: ActionTypes.PERMISSION_GROUPS_CLEAR.SUCCESS,
  };
}
